import React from 'react';
import { CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const ChatIcon: React.FC<{}> = () => (

    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.chatIcon')}</title>
        <g id='chat_bubble (e977)'>
            <path
                id='^ Name above ^'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.89998 22C4.78398 21.997 4.67898 21.952 4.59998 21.88C4.49198 21.785 4.42398 21.645 4.42398 21.49C4.42398 21.422 4.43698 21.356 4.46098 21.296L6.10998 17.08C3.75098 15.894 2.13198 13.545 2.00098 10.807C1.99998 6.5 6.48998 3 12 3C17.51 3 22 6.5 22 10.79C22 15.08 17.51 18.58 12 18.58C11.379 18.58 10.769 18.536 10.171 18.452L5.15998 21.92C5.08698 21.97 4.99698 22 4.89998 22ZM12 4C6.99998 4 2.99998 7 2.99998 10.79C2.99998 13.03 4.48998 15.13 6.99998 16.41C7.15998 16.498 7.26698 16.666 7.26698 16.859C7.26698 16.928 7.25298 16.994 7.22798 17.054L5.91898 20.211L9.91898 17.521C9.99198 17.47 10.083 17.44 10.18 17.44C10.23 17.44 10.277 17.448 10.322 17.462C10.833 17.537 11.426 17.581 12.029 17.581C12.032 17.581 12.036 17.581 12.039 17.581C17.038 17.581 21.038 14.581 21.038 10.791C21.038 7.001 16.998 4.001 11.998 4.001L12 4Z'
                fill={CONTENT_BASE}
            />
        </g>
    </svg>
);
